if (!customElements.get('product-clean-standards')) {
  customElements.define('product-clean-standards', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.clean-standards__track');
      this.dots = this.querySelector('.clean-standards__dots');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.update = () => {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        this.positions = [...this.track.children].map(card => Math.min(maximum, card.offsetLeft - this.track.children[0].offsetLeft));
        this.positions = [...new Set(this.positions)];
        this.dots.hidden = maximum <= 1;
        if (this.dots.children.length !== this.positions.length) {
          this.dots.replaceChildren(...this.positions.map((position, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'clean-standards__dot';
            button.setAttribute('aria-label', `View clean standards ${index + 1}`);
            button.setAttribute('aria-controls', this.track.id);
            button.addEventListener('click', () => this.track.scrollTo({ left: this.positions[index], behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }));
            return button;
          }));
        }
        this.markActive();
      };
      this.markActive = () => {
        const nearest = this.positions.reduce((best, position, index) => Math.abs(position - this.track.scrollLeft) < Math.abs(this.positions[best] - this.track.scrollLeft) ? index : best, 0);
        [...this.dots.children].forEach((button, index) => button.setAttribute('aria-current', String(index === nearest)));
      };
      this.track.addEventListener('scroll', this.markActive, { ...options, passive: true });
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.clean-standards__card');
        if (card && matchMedia('(max-width: 767px)').matches) this.track.scrollTo({ left: card.offsetLeft - this.track.children[0].offsetLeft });
      }, options);
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.controller.abort();
      this.observer.disconnect();
    }
  });
}
